import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import {LoginGuard} from "@services/auth/guards/login.guard";
import {SubscriberGuard} from "@services/auth/guards/subscriber.guard";
import {ActivationGuard} from "@services/auth/guards/activation.guard";
import {ImageGuard} from "@services/auth/guards/image.guard";
import {NonPayingGuard} from "@services/auth/guards/non-paying.guard";
import {NonLoggedGuard} from "@services/auth/guards/non-logged.guard";
import {ChangePhotoGuard} from "@services/auth/guards/change-photo.guard";

import {appRoutingEnum} from "@enums/appRoutingEnum";
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

const routes: Routes = [
  {path: '', redirectTo: appRoutingEnum.HOME, pathMatch: 'full'},
  {
    path: appRoutingEnum.LOGIN,
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    //canActivate: [NonLoggedGuard]
  },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.module').then( m => m.MainPageModule),
    canActivate: [NonLoggedGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'magazine',
    loadChildren: () => import('./pages/page/page.module').then( m => m.PagePageModule),
    //canActivate: [CheckGuard]
  },
  {
    path: 'magazine/:id',
    loadChildren: () => import('./pages/magazine/magazine.module').then( m => m.MagazinePageModule),
  },
  {
    path: appRoutingEnum.ACTIVATION,
    loadChildren: () => import('./pages/activation/activation.module').then(m => m.ActivationPageModule),
    canActivate: [ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.ADMIN_MESSAGES,
    loadChildren: () => import('./pages/admin-messages/admin-messages.module').then(m => m.AdminMessagesPageModule),
    canActivate: [LoginGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.ADVANCED_SEARCH_RESULT,
    loadChildren: () => import('./pages/advanced-search-result/advanced-search-result.module').then(m => m.AdvancedSearchResultPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.ADVANCED_SEARCH,
    loadChildren: () => import('./pages/advanced-search/advanced-search.module').then(m => m.AdvancedSearchPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.ARENA,
    loadChildren: () => import('./pages/arena/arena.module').then(m => m.ArenaPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.ARENA + '/:id',
    loadChildren: () => import('./pages/arena/arena.module').then(m => m.ArenaPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.BINGO,
    loadChildren: () => import('./pages/bingo/bingo.module').then(m => m.BingoPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.CHANGE_PASSWORD,
    loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordPageModule),
    canActivate: [LoginGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.CONTACT_US,
    loadChildren: () => import('./pages/contact-us/contact-us.module').then(m => m.ContactUsPageModule)
  },
  {
    path: appRoutingEnum.DIALOG + '/:id',
    loadChildren: () => import('./pages/dialog/dialog.module').then(m => m.DialogPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.FAQ,
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule)
  },
  {
    path: appRoutingEnum.FREEZE_ACCOUNT,
    loadChildren: () => import('./pages/freeze-account/freeze-account.module').then(m => m.FreezeAccountPageModule),
    canActivate: [LoginGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.FULL_SCREEN_PROFILE,
    loadChildren: () => import('./pages/full-screen-profile/full-screen-profile.module').then(m => m.FullScreenProfilePageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.INBOX,
    loadChildren: () => import('./pages/inbox/inbox.module').then(m => m.InboxPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.NOTIFICATIONS,
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.PAGE + '/:id',
    loadChildren: () => import('./pages/page/page.module').then(m => m.PagePageModule)
  },
  {
    path: appRoutingEnum.PASSWORD_RECOVERY,
    loadChildren: () => import('./pages/password-recovery/password-recovery.module').then(m => m.PasswordRecoveryPageModule)
  },
  {
    path: appRoutingEnum.PROFILE,
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.PROFILE + '/:id',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.REGISTER,
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: appRoutingEnum.SEARCH,
    loadChildren: () => import('./pages/search/search.module').then(m => m.SearchPageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.SETTINGS,
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
    canActivate: [LoginGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.SUBSCRIPTION,
    loadChildren: () => import('./pages/subscription/subscription.module').then(m => m.SubscriptionPageModule),
    canActivate: [LoginGuard, ActivationGuard, NonPayingGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.TERMS,
    loadChildren: () => import('./pages/terms/terms.module').then(m => m.TermsPageModule)
  },
  {
    path: appRoutingEnum.CHANGE_PHOTO,
    loadChildren: () => import('./pages/change-photo/change-photo.module').then(m => m.ChangePhotoPageModule),
    canActivate: [ChangePhotoGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: appRoutingEnum.HOME,
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    canActivate: [LoginGuard, SubscriberGuard, ActivationGuard, ImageGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    canActivate: [NonLoggedGuard],
    runGuardsAndResolvers: 'always'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ]
})
export class AppRoutingModule {}
